import { AxiosError } from 'axios';
import { batch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import * as AgentAPI from 'services/api/api.agent';

import { logout, UserAction } from 'store/user/user.actions';
import RootState from '../state';
import { AgentFilter, AgentInfo } from './agents.state';
import AgentsTypes from './agents.types';

export type AgentsAction =
    | { type: typeof AgentsTypes.CLEAR_AGENTS }
    | { type: typeof AgentsTypes.GET_AGENTS; payload: GetAgentsAction }
    | {
          type: typeof AgentsTypes.SET_AGENTS_ERROR;
          payload: SetAgentsErrorAction;
      }
    | {
          type: typeof AgentsTypes.SET_AGENTS_LOADING;
          payload: SetAgentsLoadingAction;
      }
    | { type: typeof AgentsTypes.SHOW_AGENTS }
    | { type: typeof AgentsTypes.FILTER_AGENTS; payload?: AgentFilter };

export interface SetAgentsLoadingAction {
    loading: boolean;
}

export interface SetAgentsErrorAction {
    error: boolean;
}

export interface GetAgentsAction {
    agents: Array<AgentInfo>;
}

export function getAgents() {
    return async (
        dispatch: ThunkDispatch<
            RootState,
            undefined,
            AgentsAction | UserAction
        >,
        getState: () => RootState
    ) => {
        const { agentsError, agentsLoading, agentsFilter } = getState().agents;

        if (agentsError) {
            dispatch(setAgentsError(false));
        }
        if (!agentsLoading) {
            dispatch(setAgentsLoading(true));
        }

        try {
            //const routingProfileID = (state.user.routingProfileId || '').split('/').slice(-1)[0];

            const companyID = getState().app.ID;
            const token = getState().auth.token!;

            const data = await AgentAPI.getAgents(companyID, token, agentsFilter);

            batch(() => {
                dispatch<AgentsAction>(setAgentsLoading(false));
                dispatch<AgentsAction>({
                    type: AgentsTypes.GET_AGENTS,
                    payload: {
                        agents: data,
                    },
                });
            });
        } catch (err) {
            const e = err as AxiosError;
            if (e.response?.status === 403) return dispatch(logout());

            dispatch(setAgentsError(true));
        }
    };
}

export function setAgentsFilter(filter?: AgentFilter): AgentsAction {
    return {
        type: AgentsTypes.FILTER_AGENTS,
        payload: filter,
    };
}

export function clearAgents(): AgentsAction {
    return {
        type: AgentsTypes.CLEAR_AGENTS,
    };
}

export function showAgents(): AgentsAction {
    return {
        type: AgentsTypes.SHOW_AGENTS,
    };
}

export function setAgentsLoading(loading: boolean): AgentsAction {
    return {
        type: AgentsTypes.SET_AGENTS_LOADING,
        payload: {
            loading,
        },
    };
}

export function setAgentsError(error: boolean): AgentsAction {
    return {
        type: AgentsTypes.SET_AGENTS_ERROR,
        payload: {
            error,
        },
    };
}
